module.exports = __webpack_public_path__ + "img/data-quality-a-z-level-2.fda005d3.svg";